import { forwardRef, createElement } from 'react';

function IconPlusCircle(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zm0 3.75a.75.75 0 01.743.648L12.75 8v3.25H16a.75.75 0 01.102 1.493L16 12.75h-3.25V16a.75.75 0 01-1.493.102L11.25 16v-3.25H8a.75.75 0 01-.102-1.493L8 11.25h3.25V8a.75.75 0 01.75-.75z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var PlusCircle = /*#__PURE__*/forwardRef(IconPlusCircle);

export default PlusCircle;
//# sourceMappingURL=PlusCircle.js.map
